var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.getResortSubareas,"loading":_vm.loading || _vm.subareasLoading,"disabled":_vm.disabled || _vm.subareasLoading,"label":"Subarea","item-value":"id","item-text":"name","clearable":""},on:{"change":_vm.setResortSubarea}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c64cc330","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ski/skistar/SkistarrResortSubareaSelect.vue
// module id = null
// module chunks = 